import { Component } from '@angular/core';

@Component({
  selector: 'app-search-property-new',
  templateUrl: './search-property-new.component.html',
  styleUrls: ['./search-property-new.component.css']
})
export class SearchPropertyNewComponent {

}
